import { GTMPageType } from 'modules/gtm/constants';
import { push } from 'modules/gtm/modules/common';
import { CurrentWishlist, GTMWishlistData } from 'modules/gtm/modules/types';

export const gtmAddToWishlist = (data: GTMWishlistData) => {
  push({
    event: 'Generic Event',
    event_name: 'add_to_wishlist',
    add_to_wishlist: {
      event_category: 'wishlist',
      event_action: 'add product',
      event_label: data.productId,
      add_to_wishlist_location: data?.pageType && GTMPageType[data.pageType],
      product_id: data.productId,
      price: data.productPrice,
    },
  });
};

export const gtmRemoveFromWishlist = (data: GTMWishlistData) => {
  push({
    event: 'Generic Event',
    event_name: 'remove_from_wishlist',
    remove_from_wishlist: {
      event_category: 'wishlist',
      event_action: 'remove product',
      event_label: data.productId,
      remove_from_wishlist_location:
        data?.pageType && GTMPageType[data.pageType],
      product_id: data.productId,
      price: data.productPrice,
    },
  });
};

export const gtmCurrentWishlist = (data: CurrentWishlist | null) => {
  push({
    event: 'Generic Event',
    event_name: 'currentWishlist',
    currentWishlist: !data
      ? []
      : {
          matsids: data.matsids,
          products: data.products,
        },
  });
};
